const binding = { modules: {}, dataActions: {} };

    (binding.modules['ext-external-script'] = {
        c: () => require('partner/modules/ext-external-script/ext-external-script.tsx'),
        $type: 'scriptModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'ext-external-script',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/ext-external-script'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };